var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ckeditor',{ref:"txtArea",staticStyle:{"border":"1px solid #000"},attrs:{"value":_vm.value,"label":_vm.lbl,"outline":_vm.outline},on:{"input":_vm.handleInput,"change":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }